import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next/pages';
import Container from 'components/Container';
import { H2 } from 'components/Text';
import { SECTION_Y } from 'components/TextPage/pageLayout';
import { findKeyByRewriteUrl } from 'urlTranslations';
import { LANDING_PAGES, landingPath } from 'utils/packageLandingPages';

// WHIT-485 round 2: the home page's way into the destination and theme
// pages, as the incumbent's destination and category tiles were.

const TILE =
  'block rounded-xl border border-tt-gray-purple bg-white px-4 py-3 text-sm font-semibold text-tt-dark-purple hover:ring-2 hover:ring-tt-dark-purple transition-all';

const HolidayIdeas: React.FC = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const group = (kind: string) =>
    LANDING_PAGES.filter(page => page.kind === kind);

  return (
    <Container containerClassName={SECTION_Y}>
      {[
        { kind: 'destination', title: t('Popular holiday destinations') },
        { kind: 'theme', title: t('Holiday ideas') },
      ].map(({ kind, title }) => (
        <section key={kind} className="mb-8 last:mb-0">
          <H2 gopher className="mb-4">
            {title}
          </H2>
          <ul className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {group(kind).map(page => (
              <li key={page.slug}>
                <Link
                  href={findKeyByRewriteUrl(
                    landingPath(page.slug),
                    router.locale,
                  )}
                  className={TILE}
                >
                  {t(`landing_${page.slug}_title`)}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </Container>
  );
};

export default HolidayIdeas;
